import React, {useState, useRef, useContext, useEffect} from 'react';
import ChantierInfoFactureView from './ChantierInfoFactureView';
import moment from 'moment/moment';
import '../ChantierInfoPhoto/ChantierInfoPhoto.css';
import {getPhoto, getUsers} from '../../../services/MadricService';
import {useParams} from 'react-router-dom';
import {MadricContext} from '../../../Context/MadricContext';
import {useNavigate} from 'react-router';
import Spinner from '../../Spinner/Spinner';

/**
 * Affiche l'historique des checkins et des photos d'un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoFacture() {
  const navigate = useNavigate();

  const {projectInfoObtained, projectInfo, setProjectInfo, listeEmploye, setListeEmploye} = useContext(MadricContext);

  const [filteredArray, setFilteredArray] = useState([]);
  const [imageOnScreen, setImageOnScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nbItems, setNbItems] = useState(20);

  const filterForm = useRef({inputRef: {label: 'Filtrer par nom'},
    dateRef: '',
    extra1: false,
    extra2: false,
    extra3: false,
    avancement: false});

  const {id} = useParams();


  const photoRef = useRef();

  useEffect(() => {
    if (listeEmploye.length === 0) {
      fetchEmploye();
    }
  }, []);

  /**
   * Permet d'allez chercher la liste d'employe
   */
  async function fetchEmploye() {
    const name = await getUsers();

    setListeEmploye(name);
  }

  /**
   * Ouvre le modal des photos
   * @param {*} photo photo à modifier
   */
  async function getPhotos() {
    setImageOnScreen(true);
    if (!projectInfoObtained.current.includes('photo')) {
      setIsLoading(true);
      const photos = await getPhoto(id);

      photos.sort((a, b) => {
        const dateCompare = b.date.localeCompare(a.date);
        if (dateCompare !== 0) {
          return dateCompare;
        }

        return b.user_id - a.user_id;
      });
      setProjectInfo((prev) => [...prev, ...photos]);
      setFilteredArray(photos);
      projectInfoObtained.current = [...projectInfoObtained.current, 'photo'];
      setIsLoading(false);
    } else {
      setFilteredArray(projectInfo.filter((item) => item.type === 'facture' || item.type === 'photo'));
    }

  }

  /**
   * Supprime le filtre de la date
   */
  function removeDate() {
    filterForm.current = {
      ...filterForm.current,
      dateRef: '',
      inputRef: {label: 'Filtrer par nom'},
    };
    filterData();
  }

  /**
   * Permet de charger plus d'éléments dans la page
   */
  function moreElements() {
    setNbItems((prev) => prev + 20);
  }

  /**
   * Permet de filtrer par le nom
   * @param {*} event event
   */
  function handleChange(event) {
    filterForm.current = {
      ...filterForm.current,
      inputRef: event,
    };
    filterData();
  }

  /**
   * filtre du extra 1
   * @param {*} event event
   */
  function handleCheckboxChange(event) {
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.checked,
    };
    filterData();
  }

  /**
   * filtre de la date
   * @param {*} event event
   */
  function handleDateChange(event) {
    filterForm.current = {
      ...filterForm.current,
      dateRef: event,
    };
    filterData();
  }

  /**
   * Permet de naviguer vers la page d'ajout de facture
   */
  function addFacture() {
    navigate('/addFacture', {state: {id}});
  }

  const filterExtra = (item1, item2, item3, item4) => {
    const {extra1, extra2, extra3, avancement} = filterForm.current;

    const areAllExtrasFalse = !extra1 && !extra2 && !extra3 && !avancement;
    const isItem1Matching = item1 === extra1 && item1;
    const isItem2Matching = item2 === extra2 && item2;
    const isItem3Matching = item3 === extra3 && item3;
    const isItem4Matching = item4 === avancement && item4;

    return areAllExtrasFalse || isItem1Matching || isItem2Matching || isItem3Matching || isItem4Matching;
  };

  const filterData = () => {
    const dateRef = filterForm.current.dateRef;
    const filteredArrays = projectInfo.filter((item) => item.type === 'facture' || item.type === 'photo').filter((item) => {
      const date1 = moment.tz(item.date, 'America/Montreal');
      const date2 = moment.tz(dateRef, 'America/Montreal');

      return ((item.user_name.toLowerCase() === filterForm.current.inputRef.label.toLowerCase() || filterForm.current.inputRef.label === 'Filtrer par nom') &&
        (date1.isSame(date2) || dateRef === '') &&
        filterExtra(item.extra1, item.extra2, item.extra3, item.avancement));
    });

    setFilteredArray(filteredArrays);
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}

      <ChantierInfoFactureView
        addFacture={addFacture}
        imageOnScreen={imageOnScreen}
        filteredArray={filteredArray}
        nbItems={nbItems}
        getPhotos={getPhotos}
        moreElements={moreElements}
        handleChange={handleChange}
        handleDateChange={handleDateChange}
        dateRef={filterForm.current.dateRef}
        inputRef={filterForm.current.inputRef}
        handleCheckboxChange={handleCheckboxChange}
        removeDate={removeDate}
        photoRef={photoRef.current} />
    </React.Fragment>
  );
}

export default ChantierInfoFacture;
